import React from 'react';
import { FadeIn } from './FadeIn';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
export function AchievementsSection() {
  const achievements = ['Llenar tu freezer de departamento (incluso si es chico) con técnica de empaque plano.', 'Recalentar tus platos para que parezcan recién hechos (sin texturas aguadas).', 'Organizar tu cocina como una línea de montaje profesional.', 'Mantener el sabor original de tus comidas por hasta 3 meses.'];
  return <section className="bg-[#F5F5F5] py-10 md:py-16 px-4 md:px-8" data-id="element-14">
      <div className="max-w-4xl mx-auto" data-id="element-15">
        <FadeIn data-id="element-16">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-5 md:mb-8" data-id="element-17">
            QUÉ VAS A LOGRAR
          </h2>
        </FadeIn>

        <div className="space-y-2 md:space-y-4" data-id="element-18">
          {achievements.map((item, index) => <FadeIn key={index} delay={0.1 * index} className="flex items-start bg-white p-4 md:p-6 rounded-xl shadow-sm border border-gray-100" data-id="element-19">
              <CheckCircleIcon className="text-[#2D5A27] mt-1 mr-4 flex-shrink-0" sx={{
            fontSize: 28
          }} data-id="element-20" />
              <p className="text-lg md:text-xl text-gray-800 font-medium" data-id="element-21">
                {item}
              </p>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}